// extracted by mini-css-extract-plugin
export default {"home":"Home_home__Iy41P","text-container":"Home_text-container__xRtsu","intro":"Home_intro__oh50e","subintro":"Home_subintro__G6zoJ"};